export function doesUserWantToLeaveFlow(){
	return new Promise((resolve, reject) =>
	{
		if($('.outer-wrapper.step-3').length !== 0){
			resolve(true);
		}
		else
		{
			Swal.fire({
				title: wpTranslatedStrings.bookingFlow.sentences.leaveBookingflow,
				text: wpTranslatedStrings.bookingFlow.sentences.doYouWantToLeave,
				icon: 'question',
				showCancelButton: true,
				confirmButtonText: wpTranslatedStrings.terms.yes,
				confirmButtonColor: '#757575',
				cancelButtonText: wpTranslatedStrings.terms.no,
				cancelButtonColor: '#c0cd2d',
				reverseButtons: true
			})
			.then(response =>
			{
				if (typeof response.isConfirmed !== 'undefined' && response.isConfirmed === true)
				{
					resolve(true);
				}
				else
				{
					reject(false);
				}
			})
			.catch(error => {
				reject(false);
			});
		}
		
	});
}
